import {TranslationKey} from '@enums'
import {CircularProgress, Grid, Stack} from '@mui/material'

import React from 'react'

import {renderFormField} from 'common'

import {ComposedComponents, UIKit} from '@components'

import {useContractTemplateFormModel} from './contract-template-view-model'
import {previewStyle} from './style'

/**
 * Contract Template View page
 */
export function ContractTemplateViewPage() {
  const {onPressBack, onPressEdit, t, contractTemplateFormFields, pdfUrl} = useContractTemplateFormModel()

  return (
    <>
      <UIKit.BackgroundCard>
        <Grid container spacing={2}>
          {contractTemplateFormFields.map((item, index) => (
            <Grid sm={4} item key={`contract-template-form-field-${index}`}>
              {renderFormField(item)}
            </Grid>
          ))}
        </Grid>
      </UIKit.BackgroundCard>

      <UIKit.BackgroundCard title={t(TranslationKey.Preview)}>
        {pdfUrl ? (
          <iframe src={`${pdfUrl}#toolbar=0&navpanes=0`} title="HTML Preview" style={previewStyle} />
        ) : (
          <Stack style={{flex: 1, justifyContent: 'center', alignItems: 'center'}}>
            <CircularProgress />
          </Stack>
        )}
      </UIKit.BackgroundCard>
      <ComposedComponents.FormButtons
        leftButton={{label: t(TranslationKey.Back), onClick: onPressBack}}
        rightButton={{label: t(TranslationKey.Edit), onClick: onPressEdit}}
      />
    </>
  )
}
